import { useSpotUser } from "@/utils/spotUser";

/**
 * Deleting historic runs and chats is the platform admin's call (DEV-1796): it
 * is destructive, platform-wide, and the only way to recover disk space. Gated
 * on `User.is_admin` — the instance-level flag, not a tenant role. Every surface
 * that offers it — Past usage, the storage dialogs, the deployment down states —
 * asks this one hook, so none of them can drift from the others.
 */
export function useCanDeleteHistory(): boolean {
  const { spotUser } = useSpotUser();
  return spotUser.is_admin;
}
